import { ReactElement } from 'react';

export const noticeTypeClassMap: any = {
  '02': 'notice_type_02',
  '03': 'notice_type_03',
  '11': 'notice_type_11'
};

export const noticeSvg = (color = '#0072EF'): ReactElement => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 1V3.50004H8.5M6 8H3M7 6H3M9 4.49411V10.5H1V0.5H5.00589C5.37277 0.5 5.55622 0.5 5.72885 0.541445C5.8819 0.57819 6.02822 0.638797 6.16243 0.72104C6.3138 0.813802 6.44352 0.943516 6.70294 1.20294L8.29706 2.79706C8.55648 3.05648 8.6862 3.1862 8.77896 3.33757C8.8612 3.47178 8.92181 3.6181 8.95855 3.77115C9 3.94378 9 4.12723 9 4.49411Z"
        stroke={color}
        strokeLinecap="square"
      />
    </svg>
  );
};

export const caretSvg = (): ReactElement => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.646469 5.50383L6.00002 0.150277L11.3536 5.50383L10.6465 6.21094L6.00002 1.56449L1.35358 6.21094L0.646469 5.50383Z"
      fill="#606A76"
    />
  </svg>
);
